import { Injectable, Output, EventEmitter } from '@angular/core';
import { MensajeModal } from '../models/mensajeModal';
import { TipoMensajeModal } from '../enum/enumTipoMensajeModal';
import { AccionBoton } from '../enum/enumAccionBoton';

@Injectable({
  providedIn: 'root'
})

export class MensajeModalService {
  @Output() ventanaModal: EventEmitter<MensajeModal> = new EventEmitter();

  constructor() { }

  modal(modal: MensajeModal) {
    this.ventanaModal.emit(modal);
  }

  mostratrModalUnaOpcion(
                          descripcion: string,
                          tipoMensajemodal: TipoMensajeModal,
                          tituloBotonPrimario: string,
                          tipoMensaje: number,
                          accion: AccionBoton,
                          cupoAsignado?: string,
                          statusCode?: number,
                          exceptionType?: string) {
    const modal = new MensajeModal();
    modal.mensaje = descripcion;
    modal.mensajeCupo = cupoAsignado;
    modal.tipoModal = tipoMensajemodal;
    modal.tituloBotonPrimario = tituloBotonPrimario;
    modal.tituloBotonSecundario = '';
    modal.tipoMensajeAlerta = tipoMensaje;
    modal.accionBoton = accion;
    modal.statusCode = statusCode;
    modal.exceptionType = exceptionType;
    this.ventanaModal.emit(modal);
  }

  mostratrModalUnaOpcionRedirect(
      descripcion: string,
      tipoMensajemodal: TipoMensajeModal,
      tituloBotonPrimario: string,
      tipoMensaje: number,
      accion: AccionBoton,
      url: string) {
    const modal = new MensajeModal();
    modal.mensaje = descripcion;
    modal.url = url;
    modal.tipoModal = tipoMensajemodal;
    modal.tituloBotonPrimario = tituloBotonPrimario;
    modal.tituloBotonSecundario = '';
    modal.tipoMensajeAlerta = tipoMensaje;
    modal.accionBoton = accion;
    this.ventanaModal.emit(modal);
  }

  mostratrModalMultiopcionLink(
      descripcion: string,
      tipoMensajemodal: TipoMensajeModal,
      tituloBotonPrimario: string,
      tituloBotonLink: string,
      tipoMensaje: number,
      accionPrimario: AccionBoton,
      accionSecundaria: AccionBoton) {

    const modal = new MensajeModal();
    modal.mensaje = descripcion;
    modal.tipoModal = tipoMensajemodal;
    modal.tituloBotonPrimario = tituloBotonPrimario;
    modal.tituloBotonSecundario = '';
    modal.tituloBotonLink = tituloBotonLink;
    modal.tipoMensajeAlerta = tipoMensaje;
    modal.accionBoton = accionPrimario;
    modal.accionBotonSecundaria = accionSecundaria;
    this.ventanaModal.emit(modal);
  }

  mostratrModalMultiopcion(
      descripcion: string,
      tipoMensajemodal: TipoMensajeModal,
      tituloBotonPrimario: string,
      tituloBotonSecundario: string,
      tipoMensaje: number,
      accion: AccionBoton) {

    const modal = new MensajeModal();
    modal.mensaje = descripcion;
    modal.tipoModal = tipoMensajemodal;
    modal.tituloBotonPrimario = tituloBotonPrimario;
    modal.tituloBotonSecundario = tituloBotonSecundario;
    modal.tipoMensajeAlerta = tipoMensaje;
    modal.accionBoton = accion;
    this.ventanaModal.emit(modal);
  }

}
